import { render, staticRenderFns } from "./no-setting.pug?vue&type=template&id=3fac55e7&lang=pug&"
import script from "./no-setting.ts?vue&type=script&lang=ts&"
export * from "./no-setting.ts?vue&type=script&lang=ts&"
import style0 from "./no-setting.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports